"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumpPage = void 0;
var react_1 = __importDefault(require("react"));
var BreadCrumpPage_module_scss_1 = __importDefault(require("./BreadCrumpPage.module.scss"));
var BreadCrumpPage = function (props) {
    var links = props.links;
    return (react_1.default.createElement("div", { className: BreadCrumpPage_module_scss_1.default.breadCrump },
        links.slice(0, links.length - 1).map(function (link) { return (react_1.default.createElement("a", { key: link.name, className: BreadCrumpPage_module_scss_1.default.breadCrump__item, href: link.url }, link.name)); }),
        react_1.default.createElement("a", { className: "".concat(BreadCrumpPage_module_scss_1.default.breadCrump__item, " ").concat(BreadCrumpPage_module_scss_1.default.breadCrump__item_active), href: links[links.length - 1].url, onClick: function (event) {
                event.preventDefault();
                event.stopPropagation();
            } }, links[links.length - 1].name)));
};
exports.BreadCrumpPage = BreadCrumpPage;
